module.exports = __webpack_public_path__ + "img/3-4.1ab0eb3d.svg";